import { render, staticRenderFns } from "./WaiverSignature.vue?vue&type=template&id=65e451d6&scoped=true"
import script from "./WaiverSignature.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaiverSignature.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WaiverSignature.vue?vue&type=style&index=0&id=65e451d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e451d6",
  null
  
)

export default component.exports